const Error = () => {
  return (
    <section className="error">
      <div className="wrapper flexError">
        <h2>Looks like you've gotten lost...</h2>
        <p>
          Error 404 - please navigate home through the logo in the top left
          corner of the page.
        </p>
      </div>
    </section>
  );
};

export default Error;
